import { axiosInstance } from '../axios';

const API_URL = 'api/plannedServices';
class PlannedServiceService {
  async getPlannedServices(params) {

    return axiosInstance.get(
        `${API_URL}/plannedServicesList`,
        {
          params: params,
        },
    );
  }

  async get(plannedServiceId) {
    return axiosInstance.get(
        `${API_URL}/plannedService/${plannedServiceId}`);
  }

  async save(plannedServiceDTO) {
    return axiosInstance.post(
      `${API_URL}/plannedService`,
      plannedServiceDTO,
    );
  }

  async deletePlannedServices(plannedServiceIds) {
    let data = new FormData();
    plannedServiceIds.forEach(id => data.append('ids', id) );

    return axiosInstance.delete(
        `${API_URL}/delete-plannedservices`,
        { data:data },
    );
  }

  async deletePlannedServiceInstances(plannedServiceInstanceIds) {
    let data = new FormData();
    plannedServiceInstanceIds.forEach(id => data.append('ids', id) );

    return axiosInstance.delete(
        `${API_URL}/delete-plannedserviceinstances`,
        { data:data },
    );
  }

  async moveToDate(plannedServiceInstanceId, date) {
    let data = new FormData();
    data.append('date', date);
    data.append('plannedServiceInstanceId', plannedServiceInstanceId);
    return axiosInstance.post(`${API_URL}/move-to-date`, data);
  }

  async setStateLeftUndoneServiceInstances(plannedServiceInstanceIds) {
    let data = new FormData();
    plannedServiceInstanceIds.forEach(id => data.append('ids', id));

    return axiosInstance.post(`${API_URL}/set-state-left-undone`, data);
  }
}

export default new PlannedServiceService();
